<template>
  <header class="titleUrl">
    <h1 class="titleUrl__title" v-if="title">{{ title }}</h1>
    <!-- @todo - maybe use https://codepen.io/leonardofaria/pen/rNxZJad for long email addresses -->
    <a :href="url" class="titleUrl__url" target="_blank" v-if="url"
      >{{ domain
      }}<sup class="openNewTabIcon"
        >&zwj;<svg class="fa-symbol">
          <use xlink:href="#external-link-alt"></use></svg></sup
    ></a>
  </header>
</template>

<script>
import domain from "getdomain";
import faSymbol from "../mixins/faSymbol";

export default {
  name: "inlineTitleUrl",
  props: {
    title: {
      type: String,
    },
    url: {
      type: String,
    },
    linkText: {
      type: String,
    },
  },
  mixins: [faSymbol],
  created: function () {
    this.createSymbol("external-link-alt");
  },
  computed: {
    domain() {
      if (this.linkText && this.linkText !== "") return this.linkText;
      return this.url.includes(process.env.S3_BASE_URL)
        ? domain.get(process.env.SITE_URL)
        : domain.get(this.url);
    },
  },
};
</script>

<style lang="scss">
@import "../../styles/variables.scss";
@import "../../styles/mixins.scss";

.titleUrl {
  & > * {
    display: inline;
    margin-bottom: 0;
    font-weight: $bold-weight;
  }
}
.titleUrl__title {
  font-size: 1.5em;
  margin-right: 0.5em;
  line-height: 1;
}

.titleUrl__url {
  text-decoration: none;
  white-space: nowrap;
}
</style>
